module.exports = __webpack_public_path__ + "static/img/bottom-right.48cafc47.png";